module.exports = __webpack_public_path__ + "img/81ne.9548a3c0.svg";